module.exports = __webpack_public_path__ + "img/black-friday.0f00fb78.png";